<!-- components/StatusBadge.vue -->
<template>
  <span :class="badgeClass" class="badge fs-10 px-3 ">
    <i :class="statusIcon" v-if="showIcon"></i> 
    <span>{{ displayText }}</span>
  </span>
</template>

<script>
export default {
  name: 'StatusBadge',
  props: {
    status: {
      type: String,
      required: true,
      validator: (value) => ['pending', 'approved', 'completed', 'received', 'partially_received', 'rejected', 'rejected_returned', 'draft', 'ordered', 'cancelled'].includes(value)
    },
    showIcon: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    badgeClass() {
      const classes = {
        'pending': 'badge-warning-subtle text-warning',
        'approved': 'badge-success-subtle text-success',
        'completed': 'badge-success-subtle text-success',
        'received': 'badge-primary-subtle text-primary',
        'partially_received': 'badge-warning-subtle text-warning',
        'rejected': 'badge-danger-subtle text-danger',
        'rejected_returned': 'badge-danger-subtle text-danger',
        'draft': 'badge-secondary-subtle text-secondary',
        'ordered': 'badge-info-subtle text-info',
        'cancelled': 'badge-danger-subtle text-danger'
      }
      return classes[this.status] || 'badge-secondary-subtle text-secondary'
    },
    
    displayText() {
      const texts = {
        'pending': 'Pending',
        'approved': 'Approved',
        'completed': 'Completed',
        'received': 'Received',
        'partial_received': 'Partially Received',
        'rejected': 'Rejected',
        'rejected_returned': 'Rejected & Returned',
        'draft': 'Draft',
        'ordered': 'Ordered',
        'cancelled': 'Cancelled'
      }
      return texts[this.status] || this.status
    },
    
    statusIcon() {
      const icons = {
        'pending': 'fas fa-clock',
        'approved': 'fas fa-check-circle',
        'rejected': 'fas fa-times-circle',
        'rejected_returned': 'fas fa-times-circle',
        'completed': 'fas fa-check-circle',
        'received': 'fas fa-check-circle',
        'partially_received': 'fas fa-hourglass-half',
        'draft': 'fas fa-file-alt',
        'ordered': 'fas fa-truck',
        'cancelled': 'fas fa-ban'
      }
      return icons[this.status] || 'fas fa-tag'
    }
  }
}
</script>

<style scoped>
.badge {
  font-weight: 700;
  border-radius: 20px;
  display: inline-flex;
  align-items: center;
  gap: 6px;
}

.fs-10 {
  font-size: 10px;
}

/* Status specific styles */
.badge-warning-subtle {
  background-color: #fff3e0;
  color: #ff7300;
}

.badge-success-subtle {
  background-color: #e8f5e9;
  color: #2e7d32;
}

.badge-danger-subtle {
  background-color: #ffebee;
  color: #ff0000;
}

.badge-primary-subtle {
  background-color: #e3f2fd;
  color: #1976d2;
}

.badge-secondary-subtle {
  background-color: #f5f5f5;
  color: #757575;
}

.badge-info-subtle {
  background-color: #e0f7fa;
  color: #0097a7;
}

.badge-dark-subtle {
  background-color: #eceff1;
  color: #455a64;
}
</style>